import type { AppConfig } from "../../types/appConfig";
import type { TrainingTemplate } from "./Training.typed";
import { assertResponseOk, fetchZekay } from "../zekay/httpClient";

export class TrainingModel {
  private zekayAPI: string;

  constructor(config: AppConfig) {
    this.zekayAPI = config.zekayAPI;
  }

  async getTrainingTemplateById(
    templateId: string,
    token: string,
  ): Promise<TrainingTemplate | null> {
    const response = await fetchZekay(
      `${this.zekayAPI}/portal/v2/training-templates/${templateId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      },
    );
    if (response.status === 404) return null;
    await assertResponseOk(response);

    return (await response.json()) as TrainingTemplate;
  }
}
